import Color from '../Color.js';
import { type } from '../utils/index.js';
import interpolator from '../interpolator/index.js';
export default (function (col1, col2) {
  var f = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0.5;
  var mode = (arguments.length <= 3 ? undefined : arguments[3]) || 'lrgb';
  if (!interpolator[mode] && !(arguments.length <= 3 ? 0 : arguments.length - 3)) {
    // fall back to the first supported mode
    mode = Object.keys(interpolator)[0];
  }
  if (!interpolator[mode]) {
    throw new Error("interpolation mode ".concat(mode, " is not defined"));
  }
  if (type(col1) !== 'object') col1 = new Color(col1);
  if (type(col2) !== 'object') col2 = new Color(col2);
  return interpolator[mode](col1, col2, f).alpha(col1.alpha() + f * (col2.alpha() - col1.alpha()));
});